<template>
  <b-nav-item-dropdown id="user-dropdown" right>
    <template v-slot:text>
      <b-badge
        variant="danger"
        class="draft-notification-counter"
        v-if="hasDraftCases"
        >{{ draftCases.length }}
      </b-badge>
      <b-icon-person-circle
        variant="light"
        class="menu-icon"
        v-b-tooltip="$t('header.user-menu')"
      />
    </template>
    <!-- username and login -->
    <b-dropdown-item disabled id="user"
      >{{ realusername }} [{{ user }}]</b-dropdown-item
    >
    <b-dropdown-divider />
    <!-- drafts if any -->
    <b-dropdown-item
      @click="$bvModal.show('case-draft-modal-list')"
      v-if="hasDraftCases"
    >
      <b-icon-bell-fill variant="primary" class="mr-2"></b-icon-bell-fill>
      <span class="notification-label">
       {{  $t("notification.notifications") }}
        <b-badge variant="primary" class="draft-count">{{
          draftCases.length
        }}</b-badge>
      </span>
    </b-dropdown-item>
    <draft-cases v-if="draftCasesEnabled"></draft-cases>
    <!-- my preferences -->
    <b-dropdown-item
      href="#"
      id="Preferences"
      v-if="showMyPreferences"
      @click.prevent="getUserInformation()"
    >
      <b-icon-person-fill class="mr-2" />
      {{ $t('header.user') }}
    </b-dropdown-item>
    <b-dropdown-divider v-if="hasDraftCases || showMyPreferences"></b-dropdown-divider>
    <!-- about -->
    <b-dropdown-item href="#" id="about" @click.prevent="about()">
      <b-icon-info-circle class="mr-2"></b-icon-info-circle>
      {{ $t('header.about') }}
    </b-dropdown-item>
    <b-dropdown-divider></b-dropdown-divider>
    <!-- logout -->
    <b-dropdown-item href="#" id="logout" @click.prevent="logout()">
      <b-icon-power class="mr-2" aria-hidden="true"></b-icon-power> {{  $t("login.logout-button") }}
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
//---- components ---------
import DraftCases from '@/app/components/callcenter/draft/DraftCases.vue';
//---- mixins -------------
//---- services -----------
import kmOfflineService from "@/app/services/kmoffline.service.js"
//---- 3rd-parties --------
import {
  BIconPower,
  BIconPersonCircle,
  BIconPersonFill,
  BIconBellFill,
  BIconInfoCircle,
} from 'bootstrap-vue';

export default {
  components: {
    BIconPower,
    BIconPersonCircle,
    BIconPersonFill,
    BIconBellFill,
    BIconInfoCircle,
    DraftCases,
  },
  methods: {
    async getUserInformation() {
      if (!await this.checkForUnsavedAuthoringModifications())
        return;
      this.safeRouterPush('/my-preferences');
    },
    async about() {
      if (!await this.checkForUnsavedAuthoringModifications())
        return;
      this.safeRouterPush('/about');
    },
    async logout() {
      if (!await this.checkForUnsavedAuthoringModifications())
        return;
      window.sessionStorage.clear();
      window.location.href = window.location.href.replace(/:\/\/([^/]+)\/([^/]+)\/.*$/g, "://$1/$2/logout.action");
    },
  },
  computed: {
    //checks if the project is open
    isProjectOpen() {
      return this.$store.getters['projectData/isProjectOpen'];
    },
    //gets the current profile data(along with quests info)
    currentProfile() {
      return this.$store.getters['projectData/currentProfile'];
    },
    user() {
      return this.$store.getters['header/userId'];
    },
    tools() {
      return this.$store.getters['header/tools'];
    },
    draftCases() {
      return this.$store.getters['draft/draftCases'];
    },
    hasDraftCases() {
      return this.draftCasesEnabled && this.$store.getters['draft/hasDraftCases'];
    },
    showMyPreferences() {
      return this.tools.includes('My Preferences');
    },
    realusername() {
      return this.$store.getters["header/userProperties"]?.REAL_NAME || "";
    },
    currentSkin() {
      return this.$store.getters['header/currentSkin'];
    },
    hasFieldServiceSkin() {
      return this.currentSkin == 'Field Service';
    },
    isReplica() {
      return kmOfflineService.isReplica()
    },
    draftCasesEnabled() {
        return !this.isReplica && this.isProjectOpen && !this.hasFieldServiceSkin
    }
  },
};
</script>
<style scoped>
.draft-notification-counter {
  position: absolute;
  min-height: 1.5em;
  min-width: 1.5em;
  padding: 0.25em;
  line-height: 1;
  border-radius: 10em;
  font-size: 70%;
  font-weight: 700;
  z-index: 5;
  font-size: calc(0.7em);
  top: 0px;
  left: 6px;
}
.notification-label {
  color: #007bff !important;
  font-weight: 500;
}
.draft-count {
  font-size: 0.8rem;
  font-weight: bold;
}
#user-dropdown >>> .dropdown-menu {
  float: left !important;
  position: absolute !important;
}
</style>
